import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LobbyRoutingModule } from './lobby-routing.module';
import { LobbyComponent } from './lobby.component';
import { LobbyStatusBarComponent } from './lobby-status-bar/lobby-status-bar.component';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { TagInputModule } from 'ngx-chips';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { GridModule } from '@progress/kendo-angular-grid';
import { RadioButtonModule } from '@progress/kendo-angular-inputs';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LobbyCentralViewsModule } from './lobby-central-views/lobby-central-views.module';
import { AppointmentStatusGridModule } from '../appointment/appointment-status-grid/appointment-status-grid.module';
import { CdTimerModule } from 'angular-cd-timer';
import { LobbyStaffStatusModule } from './lobby-staff-status/lobby-staff-status.module';
import { SharedModule } from '../shared/shared.module';
import { LobbyCheckInModule } from './lobby-check-in/lobby-check-in.module';
import { LobbyWrapUpModule } from './lobby-wrap-up/lobby-wrap-up.module';

@NgModule({
  declarations: [
    LobbyComponent   
  ],
  imports: [
    CommonModule,
    GridModule,
    AppointmentStatusGridModule,
    NgbModule,
    LobbyRoutingModule,
    NgMultiSelectDropDownModule,
    DialogModule,
    TagInputModule,
    FormsModule,
    CdTimerModule,
    ReactiveFormsModule,
    NgbAccordionModule,
    RadioButtonModule,
    InputsModule,
    LobbyCentralViewsModule,
    LobbyStaffStatusModule,
    SharedModule,
    LobbyCheckInModule,
    LobbyWrapUpModule
  
  ]
})
export class LobbyModule { }
